<template v-if="image.id">
  <div class="block-image" :class="classes">
    <figure class="block-image__figure">
      <img class="block-image__image" :src="image.url" :alt="image.alt ?? 'NO ALT'" :width="image.width" :height="image.height" />
      <figcaption class="block-image__caption" v-if="block.data?.caption" v-html="block.data?.caption" />
    </figure>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const image = props.block?.data?.image

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
.block-image {
  $b: &;
  @apply max-w-3xl;
  @apply rounded overflow-hidden my-4;

  &__figure {
    // 
  }

  &__image {
    @apply w-full h-auto;
    @apply rounded overflow-hidden;
  }

  &__caption {
    @apply pt-2 text-sm opacity-60;

    #{$b}.is-root.is-wide & {
      // @apply px-4 md:px-0;
    } 
  }

  &.is-root {
    // @apply col-prose;

    &.is-wide {
      // @apply col-wide;
    }
  }

  // &.is-center {
  //   // @apply col-prose;
  // }

  // &.is-wide {
  //   // @apply max-md:col-full col-wide;
  //   @apply col-main;
  // }

  // &.is-first {
  //   // @apply mt-0;
  // }

  // &.is-last {
  //   // @apply mb-0;
  // }
}
</style>